import { ActionTypes } from '../actions/types';
import { cloneDeep } from 'lodash';
import { DokumentenModel } from '../../models/DokumentenModel';

const initialState = {
  auftragsliste: [],
  reloadToggle: false, // Wert ist egal, hauptsache, er ändert sich, damit useEffect getriggert wird
  mandant: undefined,
  sortBy: undefined,
  sortingCount: 0,
  stati: [],
  dateFrom: undefined,
  dateTo: undefined,
  toggleSort: false,
  csvExportCount: undefined,
  totalSearchResults: undefined,
  dokumente: [] as DokumentenModel[],
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_AUFTRAEGE: {
      return {
        ...state,
        auftragsliste: payload,
      };
    }
    case ActionTypes.SET_TOTALSEARCHRESULTS: {
      return {
        ...state,
        totalSearchResults: payload,
      };
    }
    case ActionTypes.SET_AUFTRAGRESEARCH_FIELD: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      return {
        ...state,
        [fieldName]: value,
      };
    }
    case ActionTypes.SET_FROM_AND_TO_DATE: {
      const von = payload.dateFrom;
      const bis = payload.dateTo;
      return {
        ...state,
        dateFrom: von,
        dateTo: bis,
      };
    }

    case ActionTypes.SET_AUFTRAEGE_SORT_BY: {
      const attributeName = payload.attributeName;
      let sortingCount = payload.sortingCount;

      if (sortingCount === 3) sortingCount = 0;
      return {
        ...state,
        sortBy: attributeName,
        sortingCount: sortingCount,
        toggleSort: !state.toggleSort,
      };
    }
    case ActionTypes.RELOAD_AUFTRAGSRESEARCH:
    case ActionTypes.UPDATE_RESET_STATI:
    case ActionTypes.UPDATE_ZUR_UEBERTRAGUNG_MARKIEREN:
    case ActionTypes.UPDATE_ZUR_TYPUEBERTRAGUNG_MARKIEREN:
    case ActionTypes.UPDATE_TYP:

    case ActionTypes.DELETE_AUFTRAG: {
      return {
        ...state,
        reloadToggle: !state.reloadToggle,
      };
    }
    case ActionTypes.COUNT_AUFTRAEGE: {
      return {
        ...state,
        csvExportCount: payload,
      };
    }
    case ActionTypes.CSVEXPORT: {
      return {
        ...state,
        csvExportDone: payload,
      };
    }
    case ActionTypes.SET_DOKUMENTENVERWEIS: {
      const tmpDokumente: DokumentenModel[] = cloneDeep(state.dokumente);
      tmpDokumente.push(payload as DokumentenModel);
      return {
        ...state,
        dokumente: tmpDokumente,
      };
    }
    default:
      return state;
  }
}
